import configModule from '@/config/config'
import { mapState } from "vuex";

export default () => ({
  data() {
    return {
      visibleSubTableConfig: {
        CP_C_SHOP_PROPERTY: 'DATA_TYPE', // 平台店铺属性-"数据类型"切换
        PS_C_SALES_INFO: 'PS_C_SPEC1_ECODE', // 商品销售属性-"属性值录入方式"切换
        PS_C_PRODIM: 'DATA_TYPE', // 商品基本属性-"属性值录入方式"切换
        CP_C_STOREDIM: 'DATA_TYPE', // 店仓属性-"属性值录入方式"切换
        CP_C_SUPPDIM: 'DATA_TYPE', // 供应商属性-"属性值录入方式"切换
        CP_C_CUSTOMER_ATTRIBUTE: 'DATA_TYPE', // 客户属性-"属性值录入方式"切换
      }
    }
  },
  updated() {
    const { itemId, tableId, tableName } = this.$router.currentRoute.params;

    this.$nextTick(() => {
      if (tableName == 'OC_B_VIPCOM_DISTRIBUTION') {
        console.log('单对象主表部分的mixin:');
        if (!this.mainFormInfo) return
        const configData = this.mainFormInfo.formData
        if (!configData.data.addcolums) {
          return
        }
        const isCopyObj = configData.data.addcolums[0].childs.find(i => i.colname == 'IS_COPY').valuedata
        const STATUS = configData.data.addcolums[0].childs.find(i => i.colname == 'STATUS').valuedata
        const isCopyAdd = vm.$route.query.ISCOPY == 'Y'

        const itemOnlyTow = () => {
          const showArr = ['PS_C_SKU_ID', 'TOT_QTY_OUT']
          // configData.data.inpubobj = configData.data.inpubobj.filter(i => showArr.includes(i.colname))
        }
        const configData_objectTab = this.mainFormInfo.buttonsData
        const canEdit = () => { // 放开保存按钮 及 去掉所有 表单不可编辑限制
          configData_objectTab.data.tabcmd.prem[0] = true // actionADD
          configData_objectTab.data.tabcmd.prem[1] = true // actionMODIFY
          configData_objectTab.data.objreadonly = false
        }
        const readonlyFn = (editArr, disabledArr) => {
          configData.data.addcolums[0].childs.forEach(i => {
            if (editArr.includes(i.colname)) {
              i.readonly = false
            } else if (disabledArr.includes(i.colname)) {
              i.readonly = true
            }
          })
        }
            const notNullFu = (requireArr, noRequireArr=[]) => {
          configData.data.addcolums[0].childs.forEach(i => {
            if (requireArr.includes(i.colname)) {
              i.isnotnull = true
            } else if (noRequireArr.includes(i.colname)) {
              i.readonly = false
            }
          })
        }
            const noImport = () => {}
            const onlyExport = () => {}
        if (isCopyObj == '1') {
          itemOnlyTow()
          if (STATUS == '2') { // 缺货
            console.log('mixin:STATUS::', 2);
            canEdit()
            const editArr = ['CP_C_LOGISTICS', 'DELIVERY_METHOD', 'CP_C_PHY_WAREHOUSE', 'REMARK']
            const disabledArr = ['SPLIT_TYPE', 'BILL_TYPE', 'PS_C_BRAND_ENAME', 'WAREHOUSE_CODE']
            readonlyFn(editArr, disabledArr)
            noImport()
          } else if (STATUS == '8') { // 占单成功
            console.log('mixin:STATUS::', 8);
            canEdit()
            const editArr = ['CP_C_LOGISTICS', 'DELIVERY_METHOD', 'REMARK']
            const disabledArr = ['SPLIT_TYPE', 'BILL_TYPE', 'PS_C_BRAND_ENAME', 'WAREHOUSE_CODE', 'CP_C_PHY_WAREHOUSE_ID']
            readonlyFn(editArr, disabledArr)
            onlyExport()
          } else {
            console.log('mixin:其它::', STATUS);
            onlyExport()
          }
        } else {
          const noRequireArr = ['CP_C_LOGISTICS_ID', 'DELIVERY_METHOD']
          notNullFu([], noRequireArr) // 非必填
        }
        if (isCopyObj == '1' || isCopyAdd) { // 只要是复制（复制、复制出来的单子的详情 两种情况）
          const requireArr = ['CP_C_LOGISTICS_ID', 'DELIVERY_METHOD']
          notNullFu(requireArr) // 必填
        }
      }
    })
    if (tableName === 'OC_B_COMPENSATE_ORDER') { // 判断是否为需要操作的表
      setTimeout(() => {
        const { detail } = R3.store.state.customize.COMPENSATE;
        // R3.store.commit('customize/REDUNDANT_ORDER_ID', 'zhoulan');
        // R3.store.commit('customize/COMPENSATE', { detail: [] });
      }, 500);
    }
    // 隐藏标准保存按钮
    let tableNameArr = ['OC_B_COMPENSATE_ORDER', 'OC_B_REFUND_ORDER_EXTRA'];
    if (tableNameArr.includes(tableName)) {
      const actionMODIFY = document.getElementById('actionMODIFY');
      if (actionMODIFY) actionMODIFY.style.display = 'none';
    }

    // 隐藏刷新
    let tableNameA = ['PS_C_SPECGROUP'];
    if (tableNameA.includes(tableName)) {
      const ActionMODIFY = document.getElementById('refresh');
      if (ActionMODIFY) ActionMODIFY.style.display = 'none';
    }
    // 刷新子表
    // if (tableName === 'OC_B_REFUND_ORDER_EXTRA' && itemId == 'New' ) { // 判断是否为需要操作的表
    // R3.store.commit('customize/clear', true);
    // }

    configModule.cssHandle.btnText() // 按钮文案调整

    let tableNameArrF = [
      ...Object.keys(this.visibleSubTableConfig),
      'PS_C_SKU', 'PS_C_CATEGORY'
    ]
    if (tableNameArrF.includes(this.$route.params.tableName)) {
      this.formHandle({ detail: {} })
    }
  },
  mounted() {
    this.handleEventListener(true)
    // window.addEventListener("R3SingleButtonClick", this.DC_B_ORDER_BACK, false)
    window.addEventListener("beforeSaveAction", this.beforeSaveHandle, false)

    // 逻辑入库单/逻辑出库单 - 根据业务单据类型关联不同通知单表【入库通知单 - colid】
    if (['SG_B_STO_IN_RESULT', 'SG_B_STO_OUT_RESULT'].includes(this.$route.params.tableName)) {
      if (this.$route.params.itemId == 'New') { // 新增页面监听
        const observer = new MutationObserver(() => {
          if (document.getElementById('SG_B_STO_IN_NOTICES_ID')) {
            setTimeout(() => {
              const SOURCE_BILL_TYPE = this.$store.state[R3.getModuleName()].updateData.SG_B_STO_IN_RESULT.default.SG_B_STO_IN_RESULT.SOURCE_BILL_TYPE
              this.formHandle({ detail: { SOURCE_BILL_TYPE } })
            }, 1000)
            observer.disconnect()
          }
          if (document.getElementById('SG_B_STO_OUT_NOTICES_ID')) {
            setTimeout(() => {
              const SOURCE_BILL_TYPE = this.$store.state[R3.getModuleName()].updateData.SG_B_STO_OUT_RESULT.default.SG_B_STO_OUT_RESULT.SOURCE_BILL_TYPE
              this.formHandle({ detail: { SOURCE_BILL_TYPE } })
            }, 1000)
            observer.disconnect()
          }
        })
        observer.observe(document.body, { childList: true, subtree: true })
      }
      window.addEventListener("notificationOfMain", this.formHandle, false)
    }
  },
  computed: {
    ...mapState('customize', ['curCategoryNode']),
  },
  watch: {
    curCategoryNode: {
      handler(val) {
        /**
        * 商品品类-父级类目名称是否末级
        * 1. 展示主表的税收分类编码、税率
        * 2. 展示两个子表：商品基本属性、商品销售属性
        * 反之不展示
        */
        let { itemId, tableId, tableName } = this.$route.params;
        if (itemId != 'New' && tableName == 'PS_C_CATEGORY') {
          let isLastNode = false
          if (val.children) {
            let routeUrl = `V.${tableName}.${tableId}.${itemId}`;
            if (!this.$store.state[routeUrl].mainFormInfo.formData.data.addcolums) {
              return
            }
            let field = this.$store.state[routeUrl].mainFormInfo.formData.data.addcolums[0].childs.find(i => i.colname == 'CATEGORY_NAME')
            let cb = (data, title) => {
              for (let i=0; i < data.length; i++) {
                if (data[i].title == title && !data[i].hasOwnProperty('children')) {
                  isLastNode = true
                  break
                } else if (data[i].children && data[i].children.length) {
                  cb(data[i].children, title)
                }
              }
            }
            cb(val.children, field.valuedata)
            console.log(isLastNode, val.children, field.valuedata)
          }
          const handler = () => {
            $('#TAX_CATEGORY_CODE').parent()[0] && ($('#TAX_CATEGORY_CODE').parent()[0].style.display = isLastNode ? 'block' : 'none')
            if (!$('#TAX_RATE').parent()[0]) {
              return
            }
            $('#TAX_RATE').parent()[0].style.display = isLastNode ? 'block' : 'none'
            $('.verticalTabs .ark-tabs-panels-nav-wrap .ark-tabs-panels-nav .ark-tabs-panels-tab').each(function(index, item){
              if (item.innerHTML.indexOf('商品基本属性') > -1 || item.innerHTML.indexOf('商品销售属性') > -1) {
                item.style.display = isLastNode ? 'block' : 'none'
              }
              if (!isLastNode && item.innerHTML.indexOf('操作日志') > -1) {
                item.click()
              }
            })
          }
          setTimeout(() => handler(), 500)
        }

      },
      immediate: true,
      deep: true
    }
  },
  /* activated() {
      if (this.$route.params.tableName == 'PS_C_SKU') {
          // 框架bug：切换菜单，activated没有返回修改的表单，故特殊处理
          const update = this.updateData.PS_C_SKU
          if (update && update.changeData.PS_C_PRO_ID) {
              this.CUST_PS_C_PRO_ID = update.changeData.PS_C_PRO_ID[0].ID
          }
      }
  }, */
  methods: { // 【脚本】类型的动作定义处理
    async OUTNOTICESITME(v) {
      const { webname } = v
      let tTable = 'SG_B_STO_TRANSFER_OUT_RESULT/249232197/New'
      let type = 'out'
      switch (webname) {
        case "noticesInDetail":
        case "noticesInList":
        case "noticesItemIn":
          tTable = 'SG_B_STO_TRANSFER_IN_RESULT/249232200/New'
          type = 'in'
          break;
        default:
          break;
      }
      const { tableName, itemId } = vm.$route.params
      await vm.service.common.publicUrlParams('/api/cs/sg/v1/check/transferCheck ', {
        id: itemId,
        type
      }).then(res => {
        if (res.data.code == 0) {
          const val = vm.$store.state[R3.getModuleName()].updateData[tableName]
          const obj = {
            id: itemId,
            defaultVal: val.default[tableName],
            defaultLabel: val.defaultLabel[tableName],
          }
          vm.$store.commit('global/tabOpen', {
            type: 'V',
            url: `/SYSTEM/TABLE_DETAIL/V/${tTable}?data=${JSON.stringify(obj)}`,
          });
        }
      })
    },
    async generateTransferOrder() {
      const { itemId } = this.$router.currentRoute.params;
      await this.service.common.publicUrlParams('/api/cs/vip/vipComReturnPo/validateGenerateTransferOrder', {id: itemId}).then(res => {
        if (res.data.code == 0) {
          /*
          通过后，跳转到逻辑调拨单新增页面，
          "(SG_B_STO_TRANSFER.ID+10)":
              发货仓(SENDER_STORE_ID)默认填充唯品会退货单的收货逻辑仓，
          "(SG_B_STO_TRANSFER.ID+90)":
              来源单据类型(SOURCE_BILL_TYPE)默认填充为唯品会退货单(400)，来源单据编号(SOURCE_BILL_NO)默认填充唯品会退货单的单据编号(BILL_NO)
           */
          const da = vm.$store.state[R3.getModuleName()].copyDataForReadOnly.addcolums
          const it1 = da[0].childs.find(i => i.colname == "CP_C_DEST_ID")
          const it2 = da[0].childs.find(i => i.colname == "BILL_NO")
          const { refobjid, valuedata } = it1
          vm.$store.commit('global/tabOpen', {
            type: 'V',
            url: `/SYSTEM/TABLE_DETAIL/V/SG_B_STO_TRANSFER/249230788/New?SENDER_STORE_ID=${refobjid},${valuedata.replace('&','_j_')}&SOURCE_BILL_NO=${it2.valuedata}`,
          });
        }
      })
    },
    DC_B_ORDER_BACK(e) {
      // 客户订单单对象-返回按钮，由于在复制页面点击返回会跳转到标准的客户订单列表，特此定制
      if (vm.$route.params.tableName == 'DC_B_ORDER') {
        const _this = this
        const haveChange = _this.testUpdataValue()
        const fn = () => {
          $utils.tabCloseAppoint(_this);
          vm.$store.commit("global/tabOpen", {
            url: '/CUSTOMIZED/ORDERMANAGER_TB/41460886?isBack=true',
            type: "C",
            label: '客户订单'
          });
        }
        if (haveChange) {
          $fcWarn({
            content: '修改的数据未保存,确定返回?',
            showCancel: true,
            onOk: fn
          })
        } else {
          fn()
        }
      }
    },
    async EXPORT_CONSIGNMENT_STORAGE_ITEM(btn) {
      const btn_api = {
        "SG_B_STO_STORE_DISTRIBUTION_ITEM_EXPROT": '/api/cs/sg/storeDistributionItemExport', // 门店配货计划明细-导出
      }
      const panelVm = vm.$_live_getChildComponent(window.vm, `${R3.getModuleName()}.TableDetailCollection`)
      const searchdata = {
        table: 'SG_B_STO_STORE_DISTRIBUTION_ITEM',
        startindex: 0,
        fixedcolumns: {},
        "objid": vm.$route.params.itemId,
        "column_include_uicontroller": true,
        "isolr": false,
          selectRows: panelVm.tableRowSelectedRows.length ? _.cloneDeep(panelVm.tableRowSelectedRows).reduce((a,b) => {
          for (const key in b) {
              b[key] = { val: b[key]}
          }
          a.push(b)
          return a
        }, []) : []
      }
      const param = new FormData();
      param.append('searchdata', JSON.stringify(searchdata));
      $fcWarn({
        className: 'ark-dialog',
        title: $it('mT.tips'), // 提示
        content: `是否确定该操作？`,
        mask: true,
        showCancel: true,
        onOk: () => {
          $utils.mainContentLoading(true)
            this.service.common.publicUrlParams(btn_api[btn.webname],param).then(res => {
            if (res.data.code == 0 && res.data.data) {
              $utils.mainContentLoading()
              this.myHook.asyncTask.call() // 唤出异步任务列表
            }
          });
        }
      });
    },
    NAIKA_R_VOID() {
      // 奶卡作废
      const ids = JSON.parse(localStorage.getItem('naikaituiSelect'))
      if (ids.length < 1) {
        $fcError('请先勾选要作废的卡号信息数据！')
        return
      }
      $fcWarn({
        className: 'ark-dialog',
        title: $it('mT.tips'), // 提示
        content: `是否确定作废选中的【${ids.length}】条卡号信息？`,
        mask: true,
        showCancel: true,
        onOk: () => {
            const query = {ID: this.$route.params.itemId, cardId: ids.join()}
          this.service.orderCenter.naika_void(query).then(res => {
            if (res.data.data.code == 0) {
              this.$Message.success(res.data.data.message)
              $('#OC_B_RETURN_AF_SEND_M #refresh').trigger('click')
            }
          });
        }
      });
    },
    PAYSAVE() {
            setTimeout(async() => {
        let ID = this.$route.params.itemId;
        let main, obj, modifyData, flag;
        if (ID == 'New') {
          ID = '-1';
          main = this.$store.state["V.OC_B_COMPENSATE_ORDER.10813.New"].updateData.OC_B_COMPENSATE_ORDER.changeData;
          main.ID = '-1';
          for (const key in main) {
            if (main[key] instanceof Array && main[key].length) {
              main[key] = main[key][0].ID || '';
            }
          }
        } else {
          main = {};
          obj = {};
          const key = `V.OC_B_COMPENSATE_ORDER.10813.${ID}`;
          const form = this.$store.state[key].mainFormInfo.formData.data.addcolums[1].childs;
          const form2 = this.$store.state[key].mainFormInfo.formData.data.addcolums[2].childs;
          form.forEach(it => {
            obj[it.colname] = it.valuedata;
            if (it.isfk) obj[it.colname] = it.refobjid;
          })
          form2.forEach(it => {
            obj[it.colname] = it.valuedata;
            if (it.isfk) obj[it.colname] = it.refobjid;
          })
          Object.assign(main, obj); // 详情-主表未修改前数据
          const defaultData = this.$store.state[key].updateData.OC_B_COMPENSATE_ORDER.default.OC_B_COMPENSATE_ORDER; // 详情-主表未修改前数据
          const updateData = this.$store.state[key].updateData.OC_B_COMPENSATE_ORDER.changeData; // 详情-主表修改后数据（含复杂类型
          modifyData = this.$store.state[key].updateData.OC_B_COMPENSATE_ORDER.modify.OC_B_COMPENSATE_ORDER; // 详情-主表修改后数据
          Object.assign(main, modifyData); // 详情-主表未修改前数据
          // 主表数据特殊处理：
          delete main.OWNERID
          main.ID = ID;
        }
        // 必填校验
        if (!main.CP_C_PHY_WAREHOUSE_ID) return this.$Message.warning($it('tip.ks')) //'实体仓库为必填项，请填写后保存！'
        if (ID != '-1' && !main.ACTUAL_COMPENSATE_FEE) return this.$Message.warning($it('tip.kt')) //'实际赔付金额为必填项，请填写后保存！'
        const payData = R3.store.state.customize.COMPENSATE;
        main.REDUNDANT_ORDER_ID = payData.other.orderId;
        const OC_B_COMPENSATE_ORDER_ITEM = payData.detail;
        const IDS = R3.store.state.customize.COMPENSATE.deleteIds;
        if (ID != '-1' && !Object.keys(modifyData).length && !IDS.length && !OC_B_COMPENSATE_ORDER_ITEM.length) {
          return // 未修改 点保存无反应
        }
        if (!OC_B_COMPENSATE_ORDER_ITEM.length) {
          this.$Message.warning('请添加商品明细！');
          return
        } else {
          for (const i of OC_B_COMPENSATE_ORDER_ITEM) {
            if (i.COMPENSATE_AMT == '0.00' || i.COMPENSATE_AMT == 0) {
              this.$Message.warning('明细赔付金额不能为0，请重新录入！');
              flag = true;
              break
            }
          }
          if (flag) return
        }
        const { data: { code, data, message } } = await this.service.orderCenter.paySaveApi({ OC_B_COMPENSATE_ORDER: main, OC_B_COMPENSATE_ORDER_ITEM, IDS }).catch(e => {
          console.error('save error !');
        });
        if (code == 0) {
          this.$Message.success(message);
          R3.store.commit('customize/COMPENSATE', { detail: [] }); // 清空明细
          setTimeout(() => {
            /*
            const _self = this;
            const { fullPath } = _self.$route;
            const { keepAliveModuleName, tableName } = _self.$store.state.global.activeTab;
            R3.store.commit('global/tabCloseAppoint', {
              routeFullPath: fullPath,
              stopRouterPush: true,
              keepAliveModuleName,
              tableName
            });
            */
            if (ID == '-1') {
              $utils.tabCloseAppoint(this);
              this.$destroy(true);
              this.$store.commit("global/tabOpen", {
                id: data.objId,
                type: "V",
                tableName: "OC_B_COMPENSATE_ORDER",
                tableId: '10813'
              });
            } else {
              $utils.tabCloseAppoint(this);
              this.$destroy(true);
              this.$store.commit("global/tabOpen", {
                type: "S",
                tableName: "OC_B_COMPENSATE_ORDER",
                tableId: '10813',
                back: true,
              });
            }
          }, 200);
        }
      }, 100);
    },
    async EXTRASAVE() {
      let { itemId, tableId, tableName } = this.$route.params;
      let routeUrl = `V.${tableName}.${tableId}.${itemId}`;
      let mainOrder = this.$store.state[routeUrl].updateData[tableName].changeData;
      let OC_B_REFUND_ORDER_ITEM = JSON.parse(JSON.stringify(R3.store.state.customize.extraoOrderDetails)) //明细
      // let IDS // 删除ids
      let ID
      if (itemId === 'New') {
        OC_B_REFUND_ORDER_ITEM.forEach(i => {
          i.OC_B_ORDER_ITEM_ID = i.ID
          i.ID = '-1'
        });
      } else {
        // 获取已入库删除ids
        let arr1 = JSON.parse(sessionStorage.getItem('copyDetails')) //详情带过来的明细
        // IDS = [...arr1].filter(x => [...OC_B_REFUND_ORDER_ITEM].every(y => y.ID !== x.ID)).map(it => it.ID); // 已经删除的Ids
        // 编辑  删除为编辑数据
        OC_B_REFUND_ORDER_ITEM.forEach((item, i) => {
          if (item.ID !== '-1' && (arr1.every(y => y.QTY_REFUND == item.QTY_REFUND) && arr1.every(y => y.AMT_ACTUAL_REFUND == item.AMT_ACTUAL_REFUND))) {
            OC_B_REFUND_ORDER_ITEM[i] = null
          }
        })

      }
      // 处理主表数据
      for (let key in mainOrder) {
        if (mainOrder[key] instanceof Array) {
          if (key === 'SOURCE_BILL_NO')
            mainOrder[key] = mainOrder[key][0].BILL_NO
          else
            mainOrder[key] = mainOrder[key][0].ID
        }
      }
      // 校验
      let regxArr = ['SOURCE_CODE', 'PAY_TYPE', 'PAY_NO'];
      for (let key in mainOrder) {
        if (regxArr.includes(key) && !mainOrder[key]) {
          if (key === 'PAY_TYPE') {
            $fcError($it('tip.kq')) //支付方式不能为空！
            return;
          } else if (key === 'SOURCE_CODE') {
            $fcError($it('tip.ho')) //原平台单号不能为空！
            return;
          } else if (key === 'PAY_NO') {
            $fcError($it('tip.kr')) //支付账号不能为空！
            return;
          }
        }
      }
      // ID
      itemId === 'New' ? mainOrder.ID = '-1' : mainOrder.ID = itemId;
      // 保存
      // 处理明细
      OC_B_REFUND_ORDER_ITEM = OC_B_REFUND_ORDER_ITEM.filter(i => i !== null);
      let OC_B_REFUND_ORDER_ITEM_Arr = []
      if (OC_B_REFUND_ORDER_ITEM.length) {
        OC_B_REFUND_ORDER_ITEM_Arr = OC_B_REFUND_ORDER_ITEM.map(i => {
          i.ISACTIVE === '是' ? i.ISACTIVE = 'Y' : i.ISACTIVE = 'N';
          return i;
        })
      }
      const { data: { code, data, message } } = await this.service.orderCenter.extraSaveApi({ OC_B_REFUND_ORDER_EXTRA: mainOrder, OC_B_REFUND_ORDER_ITEM: OC_B_REFUND_ORDER_ITEM_Arr, ID });
      if (code == 0) {
        this.$Message.success(message);
        if (itemId === 'New') {
          $utils.tabCloseAppoint(this);
          this.$destroy(true);
          this.$store.commit('global/tabOpen', {
            type: 'V',
            id: data.objId,
            tableId: '10825',
            label: $it('menu.ax'), //额外退款编辑
            tableName: 'OC_B_REFUND_ORDER_EXTRA'
          });
        } else {
          $utils.tabCloseAppoint(this);
          this.$destroy(true);
          this.$store.commit("global/tabOpen", {
            type: "S",
            tableName: "OC_B_REFUND_ORDER_EXTRA",
            tableId: '10825',
            back: true,
          });
        }

      }
    },
    formHandle({ detail }) {
      // console.log(detail)
      this.$nextTick(() => {
        const { tableName } = this.$route.params
        switch (tableName) {
          case 'CP_C_SHOP_PROPERTY':
          case 'PS_C_SALES_INFO':
          case 'PS_C_PRODIM':
          case 'CP_C_STOREDIM':
          case 'CP_C_SUPPDIM':
          case 'CP_C_CUSTOMER_ATTRIBUTE':
            // 选择字典型显示子表，否则不显示且去掉子表表单必填项
            this.handleSubTab(detail)
            break;
          case 'PS_C_CATEGORY':
            this.curCategoryNode
            break;
          case 'CP_C_SHOP':
            let isUpdate = Object.keys(detail).length ? 'true' : 'false'
            sessionStorage.setItem('cpCShop_isUpdate', isUpdate)
            break;
          case 'PS_C_SKU':
            setTimeout(() => {
              let val = $('#PS_C_PRO_ID input')[0] && $('#PS_C_PRO_ID input')[0]._value || ''
              console.log(val)
              R3.store.commit('customize/setRelationId', val)
            }, 2000)
            break;
          default:
            break;
        }
      })
    },
    handleSubTab(detail) {
      let { itemId, tableId, tableName } = this.$route.params;
      let routeUrl = `V.${tableName}.${tableId}.${itemId}`;
      let colname = this.visibleSubTableConfig[tableName]

      const handler = (isOk) => {
        $('.verticalTabs')[0].style.display = isOk ? 'block' : 'none'
        if (this.$store.state[routeUrl].tabPanels[0] && this.$store.state[routeUrl].tabPanels[0].componentAttribute) {
          let subTab = this.$store.state[routeUrl].tabPanels[0].componentAttribute.formData.data
          const columns = sessionStorage.getItem(`isnotnull_for_${tableName}`)
          if (subTab && subTab.inpubobj && columns != null) {
            this.$store.state[routeUrl].tabPanels[0].componentAttribute.formData.data.inpubobj.forEach(i => {
              if (columns.split(',').includes(i.colname)) {
                i.isnotnull = isOk // 处理子表表单必填项
              }
            })
          }
        }
      }
      if (!detail.hasOwnProperty(colname)) {
        setTimeout(() => {
          if (this.$store.state[routeUrl] && this.$store.state[routeUrl].mainFormInfo.formData.data.addcolums) {
            let field = this.$store.state[routeUrl].mainFormInfo.formData.data.addcolums[0].childs.find(i => i.colname == colname)
            let oldV = ''
            if (itemId == 'New') {
              let typeV = sessionStorage.getItem(`${tableName}_copy_type`)
              oldV = !!typeV ? field.valuedata : field.defval
            } else {
              oldV = field.valuedata
            }
            let isOk = oldV == 'object'
            handler(isOk)
          }
        }, 300)
      } else {
        let isOk = detail.hasOwnProperty(colname) && detail[colname] == 'object'
        handler(isOk)
      }
    },
    beforeSaveHandle(v) {
      const tableName = this.$route.params.tableName
      if (tableName == 'DC_B_ORDER_SEND') {
        const { data } = v.detail.parames
        for (const key in data[tableName]) {
          if (data[tableName][key] === null) {
            // 入参 null 转 0 处理 - 世新
            data[tableName][key] = 0
          }
        }
      }
    },
    handleEventListener(isAdd) {
      const tableNameArr = [
        ...Object.keys(this.visibleSubTableConfig),
        'CP_C_SHOP', 'PS_C_SKU', 'PS_C_CATEGORY'
      ]
      const { tableName } = this.$route.params
      if (tableNameArr.includes(tableName)) {
        if (isAdd) {
          window.addEventListener("notificationOfMain", this.formHandle, false)
        } else {
          window.removeEventListener("R3SingleButtonClick", null, false)
          window.removeEventListener("notificationOfMain", this.formHandle, false)
          sessionStorage.removeItem(`isnotnull_for_${tableName}`)
        }
      }
    }
  },
  destroyed() {
    this.handleEventListener(false)
    window.removeEventListener("beforeSaveAction", null, false)
  }
});
